import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReservationsService extends BaseService {

  private v2ApiUrl = this.apiUrl + 'v2/';

  constructor(protected httpClient: HttpClient) {
    super();
  }

  getOrderDetail(order_id): Observable<any> {
    return this.httpClient.get(this.v2ApiUrl + `reservation?order_id=${order_id}`, this.httpOptions);
  }

  updateStatus(order_id, parcel_status): Observable<any> {
    // 'processing', 'completed', 'canceled', 'ready', 'confirmed'
    const params = {parcel_status};
    return this.httpClient.put(this.v2ApiUrl + `reservation/updateStatus/${order_id}`, params, this.httpOptions);
  }

  getCart(dispId: string) {
    return this.httpClient.get(this.v2ApiUrl + `cart` + `?disp_id=` + dispId);
  }

  addToCart(data) {
    return this.httpClient.post(this.v2ApiUrl + `cart`, data);
  }

  submitCart(data) {
    return this.httpClient.post(this.v2ApiUrl + `reservation/`, data);
  }

  getOrderUpcoming(disp_id: string) {
    return this.httpClient.get(this.v2ApiUrl + `reservation/list?type=upcoming&disp_id=${disp_id}`, this.httpOptions);
  }

  updateItemInCart(item_id, data) {
    return this.httpClient.put(this.v2ApiUrl + `cart/update/${item_id}`, data);
  }

  removeItemInCart(item_id: string, disp_id: string) {
    return this.httpClient.put(this.v2ApiUrl + `cart/remove`, {item_id, disp_id});
  }

  addDeal(data) {
    return this.httpClient.post(this.v2ApiUrl + `deal`, data);
  }

  removeDeal(deal_id: string, disp_id: string) {
    return this.httpClient.put(this.v2ApiUrl + `deal/remove`, {deal_id, disp_id});
  }
}
